export function normalizeVaiyansClassification(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_")
    .replace(/_+/g, "_");
}

export function isVaiyansClassification(value) {
  return normalizeVaiyansClassification(value).startsWith("vaiyans_vco_");
}

export function getVaiyansDisplay(value) {
  const cls = normalizeVaiyansClassification(value);
  if (!cls.startsWith("vaiyans_vco_")) return null;

  const subtitles = {
    vaiyans_vco_game_entry: "Game Entry",
    vaiyans_vco_prediction_entry: "Prediction Entry",
    vaiyans_vco_leaderboard_reward: "Leaderboard Reward",
    vaiyans_vco_tip: "Game Entry",
  };

  const fallback = cls
    .replace(/^vaiyans_vco_/, "")
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

  return {
    title: "Vaiyans Crypto Oracle",
    subtitle: subtitles[cls] || fallback || "Interaction",
  };
}
